import './_page-header.twig';

import PageHeaderVue from 'clientside/page-header';

if (document.querySelector('.page-header')) {
  const data = JSON.parse(
    document.querySelector('.page-header__data').textContent
  );

  PageHeaderVue('.page-header__root', data);
}

export const name = 'page-header';

export function enable() {}

export default enable;
